import React from 'react'
import { connect } from 'dva'
import Switch from 'react-switch'

import actions from './actions'
import LayerInfo from './LayerInfo'
import PropTypes from 'prop-types'
import SidebarBody from '../../SidebarBody'
import styles from '../LayersContent.module.scss'

function ActiveLayersTabContent(props) {
  const toggleLayer = layer => {
    props.toggleSingleLayer(layer)
  }

  const toggleLayers = () => {
    if (!props.activeLayers.length) {
      props.toggleMultipleLayers(props.recentLayers, true)
    } else {
      props.toggleMultipleLayers(props.activeLayers, false)
    }
  }

  if (props.allLayersLoading) {
    return (
      <SidebarBody>
        <p>Loading layers...</p>
      </SidebarBody>
    )
  }

  return (
    <SidebarBody>
      <div className={styles.layersBox}>
        <div className={styles.layersBoxTitle}>
          <span>Active Layers</span>
          <Switch
            checked={props.activeLayers.length > 0}
            checkedIcon={false}
            className='ghSwitch'
            disabled={!props.activeLayers.length && !props.recentLayers.length}
            height={24}
            offColor='#333333'
            offHandleColor='#ffffff'
            onChange={toggleLayers}
            onColor='#f37735'
            onHandleColor='#ffffff'
            uncheckedIcon={false}
            width={40}
          />
        </div>
        {props.activeLayers.length > 0 ? (
          props.activeLayers.map((layer, index) => {
            return <LayerInfo key={index} layer={layer} enabled={true} assetsUrl={props.assetsUrl} toggleLayer={toggleLayer} />
          })
        ) : (
          <div className={styles.noActiveLayers}>There are no active layers.</div>
        )}
      </div>

      <div className={styles.layersBox}>
        <div className={styles.layersBoxTitle}>
          <span>Recent Layers</span>
          <span className={styles.clearRecentLayers} onClick={props.clearRecentLayers}>
            Clear
          </span>
        </div>
        {props.recentLayers.length > 0 ? (
          props.recentLayers.map((layer, index) => {
            return <LayerInfo key={index} layer={layer} enabled={false} assetsUrl={props.assetsUrl} toggleLayer={toggleLayer} />
          })
        ) : (
          <div className={styles.noActiveLayers}>There are no recent layers.</div>
        )}
      </div>
    </SidebarBody>
  )
}

ActiveLayersTabContent.propTypes = {
  activeLayers: PropTypes.array,
  allLayersLoading: PropTypes.bool,
  recentLayers: PropTypes.array,
  assetsUrl: PropTypes.string,
  //actions
  clearRecentLayers: PropTypes.func,
  toggleMultipleLayers: PropTypes.func,
  toggleSingleLayer: PropTypes.func
}

export default connect(model => {
  const { allLayersLoading, preferences } = model.layers
  const activeLayers = preferences.active
  const recentLayers = preferences.recent.reverse()
  const assetsUrl = model.app.config.GH_ASSETS_CLOUDFRONT_URL
  return {
    activeLayers,
    allLayersLoading,
    recentLayers,
    assetsUrl
  }
}, actions)(ActiveLayersTabContent)
